export default __webpack_public_path__ + "static/media/billing-icon.a9dda799.svg";